const firmware = {
  firmware: 'Firmware',
  add_firmware: 'Nuevo Firmware',
  product_code: 'Código de producto',
  version: 'Versión',
  mandatory: 'Obligatorio',
  launch: 'Lanzamiento',
  launched: 'Lanzado',
  not_launched: 'No lanzado',
  add_success_msg: 'Firmware agregado exitosamente',
  update_success_msg: 'Firmware actualizado exitosamente',
  firmware_deleted: 'Firmware eliminado',
  update_firmware: 'Actualizar Firmware',
  upload_firmware: 'Cargar Firmware',
  install_firmware: 'Instalar Firmware',
  select_firmware_msg: 'Selecciona el firmware a instalar y presiona Continuar',
  confirm_update_msg:
    '¿Estás seguro de que deseas instalar la versión del firmware {{version}} en el controlador {{controller}}?',
  confirm_update_r_msg:
    '¿Estás seguro de que deseas instalar la versión del firmware {{version}} en el lector {{reader}}?',
  firmware_error_title: 'Error de Firmware',
  error_learn_more: 'Error - Más información',
  drag_drop: 'Arrastra y suelta tu archivo aquí o',
  upload_a_file: 'Subir un archivo',
  table: {
    date: 'Fecha',
    controller: 'Controlador',
    reader: 'Lector',
    release: 'Nota de lanzamiento',
  },
};

export default firmware;
